import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  min-width: 0;
  position: relative;
  height: 100%;
  cursor: default;

  .horizont-line {
    width: 100%;
    height: 0;
    border: 1px solid ${(props) => props.theme.colors.outline};
  }

  &:has(.report-btn) {
    &:hover .report-btn {
      opacity: 0.8;
    }
  }

  .report-btn {
    position: absolute;
    top: 12px;
    right: 16px;
    border: none;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.3s;
  }
`;

export default { Wrapper };
